export default __webpack_public_path__ + "static/media/AllProductEye.352ed42c.svg";